import { Warning2 } from 'iconsax-react'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'
import { useStripe } from '@/hooks/Stripe/useStripe'
import { EPlanStatus } from '@/store/api/Stripe/Stripe.types'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { StatusCard } from './StatusCard'

export const PaymentCard = ({
  status,
  stripeCustomerId,
}: {
  status: EPlanStatus | undefined
  stripeCustomerId: string | undefined
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { generatePortalSession } = useStripe()

  const [portalSessionUrl, setPortalSessionUrl] = useState<string | undefined>()

  useEffect(() => {
    const generatePortalSessionUrl = async (stripeCustomerId: string) => {
      const portalSession = await generatePortalSession(stripeCustomerId)
      if (portalSession) {
        setPortalSessionUrl(portalSession.url)
      }
    }

    if (stripeCustomerId) {
      generatePortalSessionUrl(stripeCustomerId)
    }
  }, [stripeCustomerId])

  const redirectToPortalSession = () => {
    if (portalSessionUrl) {
      window.open(portalSessionUrl, '_blank', 'noopener,noreferrer')
    }
  }

  const redirectToPayment = () => {
    if (
      status === EPlanStatus.INCOMPLETE_EXPIRED ||
      status === EPlanStatus.INCOMPLETE ||
      status === EPlanStatus.PAUSED
    ) {
      redirectToPortalSession()
      return
    }

    navigate(AppRoutes.paymentPaywall, {
      state: {
        from: AppRoutes.dashboard,
      },
    })
  }

  const textByStatus = () => {
    if (
      status === EPlanStatus.CANCELED ||
      status === EPlanStatus.PAST_DUE ||
      status === EPlanStatus.UNPAID ||
      status === EPlanStatus.TRIALING
    ) {
      return t('dashboard.home.paymentCard.subscriptionIncomplete')
    }

    if (
      status === EPlanStatus.INCOMPLETE_EXPIRED ||
      status === EPlanStatus.INCOMPLETE ||
      status === EPlanStatus.PAUSED
    ) {
      return t('dashboard.home.paymentCard.subscriptionPaused')
    }

    return t('dashboard.home.paymentCard.paymentFailed')
  }

  return (
    <div className="w-1/2 max-md:w-full max-lg:w-3/4">
      <StatusCard
        accentColor={SocialMirrorPalette.alertRedSecondary}
        bgColor={SocialMirrorPalette.alertRedBase}
        icon={
          <Warning2
            size="20"
            color={SocialMirrorPalette.alertRedSecondary}
            variant="Bold"
          />
        }
        text={<b>{textByStatus()}</b>}
        callback={redirectToPayment}
      />
    </div>
  )
}
